import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/authConfig';

// Build timestamp: 2025-12-16T16:XX - forces new build hash

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const msalInstance = new PublicClientApplication(msalConfig);

// Make MSAL instance available globally for SignalR service
(window as typeof window & { msalInstance?: PublicClientApplication }).msalInstance = msalInstance;

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);